export type VideoProvider = "vimeo" | "youtube";

const YOUTUBE_ID = /^[A-Za-z0-9_-]{11}$/;

const YOUTUBE_HOSTS = new Set([
  "youtube.com",
  "www.youtube.com",
  "youtube-nocookie.com",
  "www.youtube-nocookie.com",
]);

const VIMEO_HOSTS = new Set(["vimeo.com", "www.vimeo.com"]);

const VIMEO_PAGE_PATH = /^\/\d+(?:\/[A-Za-z0-9]+)?\/?$/;

const VIMEO_PLAYER_PATH = /^\/video\/\d+\/?$/;

function parseHttpsUrl(value: string): URL | null {
  try {
    const url = new URL(value);
    return url.protocol === "https:" ? url : null;
  } catch {
    return null;
  }
}

function isYoutubeUrl(url: URL): boolean {
  const host = url.hostname.toLowerCase();
  let candidate: string | null = null;

  if (YOUTUBE_HOSTS.has(host)) {
    candidate =
      url.pathname.match(/^\/embed\/([^/]+)\/?$/)?.[1] ??
      (url.pathname === "/watch" ? url.searchParams.get("v") : null);
  } else if (host === "youtu.be") {
    candidate = url.pathname.match(/^\/([^/]+)\/?$/)?.[1] ?? null;
  }

  return candidate !== null && YOUTUBE_ID.test(candidate);
}

function isVimeoUrl(url: URL): boolean {
  const host = url.hostname.toLowerCase();

  return (
    (VIMEO_HOSTS.has(host) && VIMEO_PAGE_PATH.test(url.pathname)) ||
    (host === "player.vimeo.com" && VIMEO_PLAYER_PATH.test(url.pathname))
  );
}

export function videoProvider(value: string): VideoProvider | null {
  const url = parseHttpsUrl(value);

  if (!url) {
    return null;
  }

  if (isVimeoUrl(url)) {
    return "vimeo";
  }

  return isYoutubeUrl(url) ? "youtube" : null;
}
